import { AI_CONVERSATIONS_PATH, ConversationHistory, ConversationList } from '@glow/ai-contract'

const HTTP_NOT_FOUND = 404

export type FetchAiConversations = () => Promise<ConversationList | null>
export type FetchAiConversation = (conversationId: string) => Promise<ConversationHistory | null>
// False when the delete did not go through, so the row stays and an error shows; already gone counts as done
export type DeleteAiConversation = (conversationId: string) => Promise<boolean>

// null means the load failed; the history view shows an inline error instead of an empty list
const getJson = async <A>(path: string): Promise<A | null> => {
  const response = await fetch(path, { credentials: 'include' }).catch(() => null)
  return response?.ok ? ((await response.json().catch(() => null)) as A | null) : null
}

export const fetchAiConversations: FetchAiConversations = () => getJson<ConversationList>(AI_CONVERSATIONS_PATH)

export const fetchAiConversation: FetchAiConversation = (conversationId) =>
  getJson<ConversationHistory>(`${AI_CONVERSATIONS_PATH}/${encodeURIComponent(conversationId)}`)

export const deleteAiConversation: DeleteAiConversation = async (conversationId) => {
  const response = await fetch(`${AI_CONVERSATIONS_PATH}/${encodeURIComponent(conversationId)}`, {
    method: 'DELETE',
    credentials: 'include'
  }).catch(() => null)
  return response?.ok === true || response?.status === HTTP_NOT_FOUND
}
